import React, { Fragment, useRef } from "react";
import _ from "lodash";

import RegisterFields from "./RegisterFields";
import TicketFields from "./ticketFields";
import { safeConvertToLocaleDateString } from "../../../utils/dateUtils";

export const TicketEditForm = (props) => {
  const inputRef = useRef({});
  // console.log(props.fileNames);

  const getFieldValue = (name, autoFilled) => {
    const initialValue = props.initailValues ? props.initailValues[name] : null;

    if (name === "warranty" || name === "purchaseDate") {
      return initialValue
        ? safeConvertToLocaleDateString(initialValue, "en-CA")
        : undefined;
    }

    if (
      name === "serviceOrderNumber" ||
      (autoFilled && initialValue !== undefined && initialValue !== null)
    ) {
      return initialValue || "";
    }

    return inputRef.current[name];
  };

  const renderFields = () => {
    return _.map(
      TicketFields,
      ({
        label,
        name,
        type,
        options,
        required,
        disabled,
        description,
        autoFilled,
      }) => {
        const initialValue = props.initailValues
          ? props.initailValues[name]
          : null;
        const shouldDisableField =
          autoFilled &&
          initialValue !== undefined &&
          initialValue !== null &&
          initialValue !== "";

        return (
          <RegisterFields
            name={name}
            label={label}
            type={type}
            value={getFieldValue(name, autoFilled)}
            fileNames={props.fileNames}
            defaultfiles={props.defaultfiles}
            options={options}
            required={required}
            initailValue={
              props.initailValues ? props.initailValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={disabled || shouldDisableField}
            description={description}
            product={props.product}
            onViewFile={props.onViewFile}
            ticketId={props.ticketId}
            onProductFound={props.onProductFound} // Pass the callback
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
